import React, { useEffect, useState } from 'react';
import { X, Save } from 'lucide-react';
import { Competitor } from '../../services/semanticBranding';
interface CompetitorEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  competitor: Competitor | null;
  onSave: (competitor: Competitor) => void;
  isNew?: boolean;
}
const CompetitorEditModal: React.FC<CompetitorEditModalProps> = ({
  isOpen,
  onClose,
  competitor,
  onSave,
  isNew = false
}) => {
  // Initialize with empty competitor object to prevent undefined
  const emptyCompetitor = {
    marca: '',
    url: '',
    descricao: '' // Keep this in the object for API compatibility, but don't show in UI
  };
  const [competitorData, setCompetitorData] = useState<Competitor>(emptyCompetitor);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // Update local state when competitor prop or isOpen changes
  useEffect(() => {
    if (isOpen) {
      setCompetitorData(competitor || emptyCompetitor);
    }
  }, [competitor, isOpen]);
  // Reset error when modal opens or closes
  useEffect(() => {
    setError('');
  }, [isOpen]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validate fields - removed description validation
    if (!competitorData.marca?.trim()) {
      setError('Nome da marca é obrigatório');
      return;
    }
    if (!competitorData.url?.trim()) {
      setError('URL é obrigatória');
      return;
    }
    // If this is a new competitor or the description is empty, add a default description
    if (isNew || !competitorData.descricao?.trim()) {
      competitorData.descricao = `Concorrente da marca: ${competitorData.marca}`;
    }
    // Save competitor
    onSave(competitorData);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-968">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-969">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-970">
          <X size={20} data-id="element-971" />
        </button>
        <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-972">
          {isNew ? 'Adicionar concorrente' : 'Editar concorrente'}
        </h3>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md" data-id="element-973">
            {error}
          </div>}
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-974">
          <div data-id="element-975">
            <label className="block mb-1 text-sm font-medium text-gray-900" data-id="element-976">
              Nome da marca
            </label>
            <input type="text" id="competitorName" value={competitorData.marca} onChange={e => setCompetitorData({
            ...competitorData,
            marca: e.target.value
          })} placeholder="Ex: Concorrente Inc." className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" disabled={isLoading} required data-id="element-977" />
          </div>
          <div data-id="element-978">
            <label className="block mb-1 text-sm font-medium text-gray-900" data-id="element-979">
              URL
            </label>
            <input type="url" id="competitorUrl" name="url" value={competitorData.url} onChange={e => setCompetitorData({
            ...competitorData,
            url: e.target.value
          })} placeholder="https://www.concorrente.com" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" disabled={isLoading} autoComplete="off" required data-id="element-980" />
          </div>
          <div className="flex justify-end space-x-2 pt-2" data-id="element-981">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center" data-id="element-982">
              <X size={16} className="mr-2" data-id="element-983" />
              Cancelar
            </button>
            <button type="submit" className="px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 flex items-center" data-id="element-984">
              <Save size={16} className="mr-2" data-id="element-985" />
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default CompetitorEditModal;